module.exports = __webpack_public_path__ + "img/item7.c61f332e.png";